import React, { Component } from 'react';

// ErrorAlertComponent Component
class ErrorAlertComponent extends Component {
  render() {
    return(
      <div className="alert alert-warning">
        <strong>Erreur :</strong> {this.props.message}
      </div>
    );
  }
}
export default ErrorAlertComponent;



// WEBPACK FOOTER //
// ./src/components/ErrorAlert.js